<template>
	<div class="info-content">
		<el-form label-width="80px">
			<el-form-item label="选择样式">
				<el-select filterable v-model="list.styleSelect" value-key="lable" style="width: 100%">
					<el-option :label="optItem.dictLabel" :value="optItem.dictValue" v-for="(optItem, index) in styleSelectData" :key="index + 'option_selected'"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="文字内容">
				<el-input type="textarea" :rows="4" v-model="list.content"></el-input>
			</el-form-item>
			<el-form-item label="文字颜色">
				<el-color-picker v-model="list.textColor" show-alpha></el-color-picker>
			</el-form-item>
			<el-form-item label="字体大小">
				<el-input-number v-model="list.fontSize" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="字体粗细">
				<el-input-number v-model="list.fontWeight" placeholder="单位100倍数（100）" controls-position="right" :step="100" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="行高">
				<el-input-number v-model="list.fontLineHeight" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="文字布局">
				<el-select v-model="list.textAlign" value-key="lable">
					<el-option :label="optItem.dictLabel" :value="optItem.dictValue" v-for="(optItem, index) in text_align_option" :key="index + 'option_selected'"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="外边距">
				<el-input-number v-model="list.marginTop" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="内边距">
				<el-input-number v-model="list.paddingTop" placeholder="单位像素（px）" controls-position="right" :step="2" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="左边距">
				<el-input-number v-model="list.paddingLeft" placeholder="单位'%'" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
			<el-form-item label="右边距">
				<el-input-number v-model="list.paddingRight" placeholder="单位'%'" controls-position="right" :step="1" step-strictly></el-input-number>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'text_config',
	props: ['data', 'className'],
	data() {
		return {
			list: {},
			styleSelectData: [
				{ dictLabel: '灵源样式', dictValue: 'is_style_ly' },
				{ dictLabel: '膏方样式', dictValue: 'is_style_gf' },
			],
			text_align_option: [
				{ dictLabel: '居左', dictValue: 'left' },
				{ dictLabel: '居中', dictValue: 'center' },
				{ dictLabel: '居右', dictValue: 'right' },
			],
		};
	},
	mounted() {
		this.list = this.data;
	},
	methods: {},
};
</script>

<style lang="scss" scoped>
.info-content {
	padding: 20px;
	overflow-y: auto;
}
.el-input-number {
	width: 220px;
}
</style>